import React, { Component } from 'react';
import DentalImage from './../../Images/DentalImage.jpg';
import VisionImage from './../../Images/VisionImage.jpg';
import BigDental from './../../Images/DentalImageLarge.jpg';
import BigVision from './../../Images/VisionImageLarge.jpg';
import UpgradeImg from './UpgradeImg';

class PlansFocus extends Component {
    componentDidMount() {
        require("./css/PlansFocus.css");
    }
    render() {
        return(
            <div className="Plans_Area">
                <div className="Plans_Container">
                    {/* <div className="Plan_Container">
                        <div className="Plan_Wrapper">
                                <div className="Plan_Wrapper_Content">
                                    <h4 className="Plan_Title">Medical</h4>
                                    <img src="https://picsum.photos/400" alt="Medical Plan"></img>
                                </div>
                                <div className="Plan_Button_Box">
                                    <div className="Plan_Button">
                                    <a className="Plan_Link" href="/MedicalPlans" target="_self">
                                        <p className="Plan_Button_Link">Learn More</p>
                                    </a>
                                    </div>
                                </div>
                        </div>
                    </div> */}
                    <div className="Plan_Container">
                        <div className="Plan_Wrapper">
                                <div className="Plan_Wrapper_Content">
                                    <h4 className="Plan_Title"><a className="Plan_Link" href="/DentalPlans">Dental</a></h4>
                                    <UpgradeImg id="DentalImage" class="DentalImage" alt="Dental - Woman Brushing Teeth" srcImg={DentalImage} upgrade={BigDental} ready={this.props.pageStatus}></UpgradeImg>
                                </div>
                                <div className="Plan_Button_Box">
                                    <div className="Plan_Button">
                                    <a className="Plan_Link" href="/DentalPlans" target="_self">
                                        <p className="Plan_Button_Link">Dental Plans</p>
                                    </a>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div className="Plan_Container">
                        <div className="Plan_Wrapper">
                                <div className="Plan_Wrapper_Content">
                                    <h4 className="Plan_Title"><a className="Plan_Link" href="/VisionPlans" target="_self">Vision</a></h4>
                                    <UpgradeImg id="VisionImage"  srcImg={VisionImage} alt="Vision Plan" upgrade={BigVision} ready={this.props.pageStatus}></UpgradeImg>
                                    {/* <img src={VisionImage} alt="Vision Plan"></img> */}
                                </div>
                                <div className="Plan_Button_Box">
                                    <div className="Plan_Button">
                                    <a className="Plan_Link" href="/VisionPlans" target="_self">
                                        <p className="Plan_Button_Link">Vision Plans</p>
                                    </a>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default PlansFocus;